// extracted by mini-css-extract-plugin
export default {"trendLabel":"ProductMarketTrendTable_trendLabel__3x5Tq","trendValue":"ProductMarketTrendTable_trendValue__X2fbl","valueCell":"ProductMarketTrendTable_valueCell__Ul5LU"};